import jwtDecode from "jwt-decode";

// Tool card ids on the DocTags screen a guest may open (must match toolsData ids)
export const GUEST_ALLOWED_TOOL_IDS = ["Summarizer", "paraphrase", "translator"];

// Routes a guest may visit. Everything else shows the signup popup
// and sends them back to the DocTags screen.
export const GUEST_ALLOWED_PATHS = [
  "/doctags",
  "/summarizer",
  "/paraphrase",
  "/translator",
  "/grammarcheck",
];

// Single source of truth for "is this session a guest?".
// A real logged-in user's JWT has _id / no guest role, so they are never affected.
export function getGuestIdentity() {
  const token =
    sessionStorage.getItem("token") || localStorage.getItem("token");

  if (token) {
    try {
      const decoded = jwtDecode(token);
      if (decoded.role === "guest" || decoded.authType === "guest") {
        return {
          isGuest: true,
          machineId: decoded.machineId || localStorage.getItem("machineId"),
        };
      }
      return { isGuest: false, machineId: null };
    } catch (err) {
      // fall through to localStorage flags
    }
  }

  if (localStorage.getItem("is_guest") === "true") {
    return { isGuest: true, machineId: localStorage.getItem("machineId") };
  }

  return { isGuest: false, machineId: null };
}

export function isGuestUser() {
  return getGuestIdentity().isGuest;
}

export function getGuestMachineId() {
  return getGuestIdentity().machineId;
}

export function isGuestToolAllowed(toolId) {
  return GUEST_ALLOWED_TOOL_IDS.includes(toolId);
}

export function isGuestPathAllowed(pathname) {
  const path = (pathname || "").toLowerCase();
  return GUEST_ALLOWED_PATHS.some(
    (allowed) => path === allowed || path.startsWith(`${allowed}/`),
  );
}
